package com.ervasstudio.tracoemovimento.components.sections

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.Colors.White
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px


@Composable
fun Logos(isHome: Boolean = true, isMobile: Boolean) {

    if (isMobile) {
        Row(
            modifier = Modifier.fillMaxWidth().border(width = if (isHome) 2.px else 0.px, color = if (isHome) Colors.Black else White, style = LineStyle.Solid),
            verticalAlignment = Alignment.CenterVertically
        ) {

            Image(
                modifier = Modifier
                    .fillMaxWidth()//.height(40.px)
                    .objectFit(ObjectFit.Fill), // Preenche, mas pode distorcer
                src = Res.Image.logos,
            )

        }

    }else{

        Row(
            modifier = Modifier
                .fillMaxWidth().backgroundColor(White).padding(leftRight = if (isHome)0.cssRem else 10.cssRem)

            ,

            verticalAlignment = Alignment.CenterVertically,
            //horizontalArrangement = Arrangement.SpaceBetween
        ) {

            Row(
                modifier = Modifier.fillMaxWidth().border(width = if (isHome) 2.px else 0.px, color = if (isHome) Colors.Black else White, style = LineStyle.Solid),
                verticalAlignment = Alignment.CenterVertically
            ) {

                Image(
                    modifier = Modifier
                        .fillMaxWidth()//.height(40.px)
                        .objectFit(ObjectFit.Fill), // Preenche, mas pode distorcer
                    src = Res.Image.logos,
                )



            }
        }
    }



}